import React from 'react'


export default ({ children, info, warning, danger }) => {
  const
    alertClass = danger
      ? "danger"
      : warning
        ? "warning"
        : "info",
    iconClass = (danger || warning)
      ? "exclamation"
      : "info"

  return <>
    <div className={ `alert alert-${ alertClass }` }>
      <i className={ `fas fa-circle-${ iconClass }` }/>
      { children }
    </div>
  </>
}
